import React, { useContext, useRef } from 'react';

// External components
import { Virtuoso } from 'react-virtuoso';
// import { VscError } from "react-icons/vsc";

// Context
import { UmbracoContext } from 'contexts/Umbraco';

const List = ({
	array,
	Footer,
	activeItem,
	setActiveItem,
	setSidebarOpen,
	getHighlighted,
	showMissingCoords = false,
	scrollIndex,
	col1,
	col2,
	searchQuery,
}) => {
	const { screenWidth, isTouch } = useContext(UmbracoContext);
	const scrollToItem = (ref, index) => {
		if (ref.current && index) {
			ref.current.scrollToIndex({
				index: index,
				align: 'center',
				behavior: 'instant',
			});
			return false;
		}
	};
	React.useEffect(() => {
		if (scrollIndex) {
			scrollToItem(virtuoso, scrollIndex);
		}
	}, [scrollIndex]);

	// List
	const virtuoso = useRef(null);

	return (
		<>
			{/*
			<div
				key={`vessel-menu-titles`}
				className={`landinger__item no-interaction`}>
                <p className="mb-0">
                    <strong>{col1}</strong>
                </p>
                 {array[index]?.latest && (
                                <small>{`${formatDate(
                                    array[index].latest
                                )}`}</small>
                            )} 
                <small className="mb-0">
                    <strong>{col2}</strong>
                </small>
			</div>
                */}
			{((searchQuery && array.length > 0) || !searchQuery) && (
				<>
					<Virtuoso
						// style={{ height: "50vh" }}
						ref={virtuoso}
						totalCount={array.length}
						components={{
							Footer: () => {
								return <Footer />;
							},
						}}
						itemContent={(index) => (
							<div
								key={`vessel-menu-${index}`}
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									if (isTouch) {
										activeItem?.name === array[index].name
											? setActiveItem(null)
											: setActiveItem(array[index]);

										if (screenWidth < 900) {
											setSidebarOpen(false);
										}
									}
								}}
								onMouseDown={(e) => {
									e.preventDefault();
									e.stopPropagation();
									if (!isTouch) {
										activeItem?.name === array[index].name
											? setActiveItem(null)
											: setActiveItem(array[index]);

										if (screenWidth < 900) {
											setSidebarOpen(false);
										}
									}
								}}
								className={`landinger__item ${
									array[index].disabled ? 'landinger__item--missing-data' : ''
								} ${
									!(array[index].lat && array[index].lng) && showMissingCoords
										? 'landinger__item--no-coords'
										: ''
								} ${
									activeItem?.name === array[index].name
										? activeItem.type === 'reference'
											? 'landinger__item--reference--active'
											: 'landinger__item--ongoing--active'
										: ''
								}
				
								`}>
								<p className='mb-0'>
									{array[index].name.length > 25
										? getHighlighted(array[index].name.slice(0, 25) + '...')
										: getHighlighted(array[index].name)}
								</p>

								{array[index]?.latestFormatted && (
									<small>{`${array[index].latestFormatted}`}</small>
								)}
							</div>
						)}
						className='landinger__list'
					/>
				</>
			)}
			{searchQuery && array.length === 0 && (
				<div className='text-center pt-4'>
					<p
						className='d-flex align-items-center flex-wrap justify-content-center'
						style={{ color: '#fff' }}>
						{/* <VscError className="mr-2" /> */}
						<span>
							Ingen treff på:{' '}
							<span className='text-primary'>
								<em>
									<strong>{searchQuery}</strong>
								</em>
							</span>
						</span>
					</p>
				</div>
			)}
		</>
	);
};

export default List;
